import { FilterType } from "../../components/data-table/types";

export type TableFilter<TModel> = {
  id: number;
  column: keyof TModel;
  type: FilterType;
  value: string | boolean | number | null;
  endValue?: string | boolean | number | null; // For range filters (e.g., date ranges)
  inputType?: string; // To specify the type of input (e.g., 'date', 'text', etc.)
  isNull?: boolean; // For IS NULL date comparisons
};

export type TableContextValue<TData, TFilter> = {
  tableData: TData;
  error: string | null;
  loading: boolean;
  filters: TFilter[];
  searchValue: string;
  disabledRows: (number | string)[];
  selectedItems: (number | string)[];
  perPage: number;
  page: number;
  total: number;
  hiddenColumns: string[];
};

export type TableDispatchValue<TData, TFilter>= {
    // Dispatch function to update the context state
    setItems: (value: { items: TData; total: number }) => void;
    setSearchValue: (searchValue: string) => void;
    clearSearchValue: () => void;
    addFilter: (filter: TFilter) => void;
    removeFilter: (filterToRemove: TFilter | TFilter[]) => void;
    removeAllFilters: () => void;
    selectItem: (itemId: string | string[]) => void;
    editItems: (update: any) => void;
    deleteItems: () => void;
    refreshItems: () => Promise<void>;
    setPage: (page: number) => void;
    setPerPage: (perPage: number) => void;
    addHiddenColumn: (column: string) => void;
    removeHiddenColumn: (column: string) => void;
  };

  export enum TableContextActions {
    SET_ITEMS = "SET_ITEMS",
    ADD_FILTER = "ADD_FILTER",
    REMOVE_FILTER = "REMOVE_FILTER",
    REMOVE_ALL_FILTERS = "REMOVE_ALL_FILTERS",
    SET_SEARCH_VALUE = "SET_SEARCH_VALUE",
    SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
    EDIT_SELECTED_ITEMS = "EDIT_SELECTED_ITEMS",
    DELETE_SELECTED_ITEMS = "DELETE_SELECTED_ITEMS",
    SET_DISABLED_ROWS = "SET_DISABLED_ROWS",
    CLEAR_DISABLED_ROWS = "CLEAR_DISABLED_ROWS",
    SELECT_ITEM = "SELECT_ITEM",
    SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS",
    CLEAR_SELECTED_ITEMS = "CLEAR_SELECTED_ITEMS",
    SET_PER_PAGE = "SET_PER_PAGE",
    SET_PAGE = "SET_PAGE",
    SET_HIDDEN_COLUMNS = "SET_HIDDEN_COLUMNS",
};